import { LabelSmall } from "baseui/typography"
import { FormattedMessage, useIntl } from "react-intl"
import { RELATION_TYPE } from "../../../services/objects"
import { LogicRefrerence } from "../../components/LogicReference/LogicReference"
import { IFlapVar } from './types'
import InsightsPanel from "./InsightsPanel"

export const SideviewPanel = (props: IFlapVar) => {
     
    const intl = useIntl();
    return (
        <>
        <InsightsPanel {...props}></InsightsPanel>

        </>
    )
}